module.exports = __webpack_public_path__ + "img/service-image-1.png";